module.exports = __webpack_public_path__ + "static/media/20ECE32.a532f8a2.jpg";